<template>
  <v-container
    class="auth"
    fill-height
    container--fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md4
      >
        <v-img
          :src="logo"
          :lazy-src="logo"
          alt="AIVIA"
          max-height="90"
          contain
        />
        <v-card> 
          <v-layout
            wrap
          >
            <v-flex
              verify
              py-5 
              px-5
              xs12
              md12
            >
              <v-icon>mdi-email-outline</v-icon>
              <div v-if="loading">
                <h3>{{ $t('verifyemail.verifying') }}</h3>
                <v-progress-linear :indeterminate="true" />
              </div>
              <div v-if="error">
                <h3>{{ $t('verifyemail.activationFailed') }}</h3>
                <p>{{ error }}</p>
              </div>
              <div v-else-if="!loading">
                <h3>{{ $t('verifyemail.activated') }}</h3> 
                <p>
                  {{ $t('verifyemail.activatedText') }}
                  <br>{{ $t('verifyemail.please') }} 
                  <router-link to="/login">
                    <strong>{{ $t('verifyemail.login') }}.</strong>
                  </router-link>
                </p>
                <v-btn
                  class="primary"
                  block
                  :disabled="loading"
                  :loading="loading"
                  @click="$router.push('login')"
                >
                  {{ $t('verifyemail.login') }}
                </v-btn>
              </div>    
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { onLogin } from "@/vue-apollo.js";
import { mapMutations } from "vuex";

export default {
  name: 'VerifyEmail',
  data: () => ({
    logo: require('@/images/logo@2x.png'), 
    loading: true,
    error: false,
  }),
  computed: {

  },
  mounted() {
     this.verifyemail();
  },
  methods: {
    ...mapMutations("app", ["setIsLoggedIn"]),
    verifyemail() {
        this.$apollo.mutate({
            mutation: require('@/graphql/mutations/VerifyEmail.gql'),
            variables: {
                token: this.$route.params.id || '',
                email: this.$route.query.email || '',
            }       
        }).then(data => {
            gtag('event', 'Account Verified', {
              'event_category': 'Package Sales',
              'event_label': 'Register Form',
            });
            setTimeout(()=>{
              if (data.data.verifyEmail == null) {
                  this.error = this.$t('verifyemail.error')
                  this.loading = false;
                  return
              }   
              onLogin(
                this.$apollo.provider.defaultClient,
                data.data.verifyEmail.access_token
              ).then(() => {
                this.setIsLoggedIn(true)
                localStorage.setItem(
                  "auth-token-expires",
                  data.data.verifyEmail.expires_in
                );
                if (localStorage.getItem("trader-mode") === "true") {
                  this.$router.push("/trader/dashboard");
                } else {
                  this.$router.push("/dashboard");
                }
              });
            }, 500)
        }).catch(error => {
            this.error = "Server Error"
            this.loading = false;
        })
    },
  }
}
</script>

<style lang="scss">
.verify {
    text-align: center;
    h3 {
        margin-top: 6px;
    }
    .v-icon {
         text-align: center;
         font-size: 70px;
         display: block;
    }
}
</style>
